import { useMemo, useState } from "react";

export type AppRuntimeState = {
  isCloudMode: boolean;
  interactionMode: string;
  targetMachineId: string;
  setTargetMachineId: React.Dispatch<React.SetStateAction<string>>;
  operatorName: string;
  setOperatorName: React.Dispatch<React.SetStateAction<string>>;
  operatorId: string;
  setOperatorId: React.Dispatch<React.SetStateAction<string>>;
  webClientId: string;
};

function getInitialSearchParam(...keys: string[]) {
  const searchParams = new URLSearchParams(window.location.search);
  for (const key of keys) {
    const value = searchParams.get(key);
    if (value) {
      return value;
    }
  }
  return "";
}

export function useAppRuntime(): AppRuntimeState {
  // 运行模式、目标机器和操作员信息统一在这里收口，避免 App.tsx 到处直接读取 URL 参数。
  const isCloudMode = ((process.env.REACT_APP_RUNTIME_MODE || "kiosk").toLowerCase() === "cloud");
  const interactionMode = useMemo(() => getInitialSearchParam("touchMode") || "hybrid", []);
  const fixedWebClientId = useMemo(() => getInitialSearchParam("webClientId", "clientId"), []);

  const [targetMachineId, setTargetMachineId] = useState<string>(() => {
    return getInitialSearchParam("machineId", "targetMachineId")
      || process.env.REACT_APP_TARGET_MACHINE_ID
      || "kiosk-001";
  });
  const [operatorName, setOperatorName] = useState<string>(() => getInitialSearchParam("operatorName", "operator", "username"));
  const [operatorId, setOperatorId] = useState<string>(() => getInitialSearchParam("operatorId", "userId"));

  const webClientId = useMemo(() => {
    if (fixedWebClientId) {
      return fixedWebClientId;
    }
    const base = process.env.REACT_APP_CLOUD_WEB_ID || "cloud-web";
    return base + "-" + targetMachineId;
  }, [fixedWebClientId, targetMachineId]);

  return {
    isCloudMode,
    interactionMode,
    targetMachineId,
    setTargetMachineId,
    operatorName,
    setOperatorName,
    operatorId,
    setOperatorId,
    webClientId,
  };
}
